export enum DataTypes {
	string = 0,
	number = 1,
	boolean = 2,
	datetime = 3,
	object = 4,
}
